import styles from './index.module.scss';
import ProductContent from './ProductContent';

const TempCommon = ({ jumpForm }: any) => {
    return (
        <div className={styles.landing}>
            <ProductContent jumpForm={jumpForm} />
        </div>
    );
};
export default function Teaser({ jumpForm }: any) {
    return <TempCommon jumpForm={jumpForm}></TempCommon>;
}
